import { createSlice } from '@reduxjs/toolkit';

export interface IConfirmModal {
    show: boolean;
    title: string;
    contentBody: string | HTMLDivElement;
    action: () => void;
}

interface IGeneralSlice {
    confirmModal: IConfirmModal;
    versionModal: boolean;
}

const initialGeneral: IGeneralSlice = {
    confirmModal: {
        show: false,
        title: '',
        contentBody: '',
        action: () => {
            //noop
        },
    },
    versionModal: false,
};

const generalSlice = createSlice({
    name: 'general',
    initialState: initialGeneral,

    reducers: {
        setConfirmModal: (state, action) => {
            state.confirmModal = action.payload;
            return state;
        },
        setVersionModal: (state, action) => {
            state.versionModal = action.payload;
            return state;
        },
    },
});

export default generalSlice;
